var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUpS48Filled = function SvgIconUpS48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.3 28.33-6.8-11.6c-.53-.9-1.46-1.43-2.5-1.43s-1.98.54-2.5 1.43l-6.8 11.6a2.91 2.91 0 0 0-.01 2.91c.51.9 1.48 1.46 2.52 1.46h13.6c1.04 0 2-.56 2.52-1.46.52-.9.51-2.01-.01-2.91h-.02Z",
    fill: "current"
  })));
};
export default SvgIconUpS48Filled;